import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'motion/react';
import styles from './ScrollPhoto.module.css';

function ScrollPhoto() {
  const { scrollY } = useScroll();
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize.width <= 768;
  const scrollRange = [0, windowSize.height || 800];

  // Responsive transforms: photo starts on the right in Hero and slides to the left in About on scroll
  const rawWidth = useTransform(
    scrollY,
    scrollRange,
    isMobile ? ['90vw', '90vw'] : ['35vw', '38vw'],
    { clamp: true }
  );

  const rawHeight = useTransform(
    scrollY,
    scrollRange,
    isMobile ? ['40vh', '40vh'] : ['70vh', '70vh'],
    { clamp: true }
  );

  const rawLeft = useTransform(
    scrollY,
    scrollRange,
    isMobile ? ['5vw', '5vw'] : ['54vw', '8vw'],
    { clamp: true }
  );

  // Absolute positioning top tracking: stays fixed to viewport by shifting top by scrollY,
  // then clamps after scrollRange so it scrolls out of view with the About section.
  const startTop = isMobile ? 100 : 0.15 * windowSize.height;
  const endTop = isMobile 
    ? (windowSize.height + 100) 
    : (windowSize.height + 0.15 * windowSize.height);

  const rawTop = useTransform(
    scrollY,
    scrollRange,
    [startTop, endTop],
    { clamp: true }
  );

  // Smooth out all transformations with spring physics to eliminate linear rigidity on scroll
  const springConfig = { stiffness: 75, damping: 20, mass: 0.6, restDelta: 0.001 };
  const width = useSpring(rawWidth, springConfig);
  const height = useSpring(rawHeight, springConfig);
  const left = useSpring(rawLeft, springConfig);
  const top = useSpring(rawTop, springConfig);

  const borderRadius = useTransform(
    scrollY,
    scrollRange,
    [isMobile ? '12px' : '20px', isMobile ? '12px' : '20px'],
    { clamp: true }
  );

  return (
    <motion.div
      className={styles.photoContainer}
      style={{
        width,
        height,
        left,
        top,
        borderRadius,
      }}
      initial={{ opacity: 0, scale: 1.05 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
    >
      <img
        src={process.env.PUBLIC_URL + '/pro.png'}
        alt="Balaram — Portrait"
        className={styles.image}
      />
    </motion.div>
  );
}

export default ScrollPhoto;
